<template>
  <HKLModal
    ref="modal"
    class="align-btn-center"
    size="medium"
    :hasCancelBtn="false"
    :title="$t('tenancy.lifecycle.statusTitle')"
  >
    <HKLTable
      class="lifecycle non-margin"
      :columns="columns"
      :dataSource="parsedHistories"
    />
  </HKLModal>
</template>

<script>
import HKLModal from '@/controls/Modal/HKLModal.vue'
import HKLTable from '@/controls/Table/HKLTable.vue'
import { useRefModal } from '@/controls/Modal/modal.hook'
import { computed, unref } from 'vue-demi'
import i18n from '@/utils/i18n'
import { useTenancyHistories } from './hook'
import { TENANCY_HISTORY_TYPE } from './consts'

import dateUtil from '@/utils/dateUtil'
import { useStoreGetters } from '@/store'
import lodash from 'lodash'

export default {
  components: {
    HKLTable,
    HKLModal,
  },
  setup () {
    const { currentTenancy } = useStoreGetters('ccd', ['currentTenancy'])
    const modalHook = useRefModal()
    const columns = computed(() => [{
      dataIndex: 'status',
      title: i18n.t('table.header.status'),
    }, {
      dataIndex: 'displayName',
      title: i18n.t('table.header.username'),
    }, {
      dataIndex: 'date',
      title: i18n.t('table.header.date'),
    }])
    const { data: histories } = useTenancyHistories()
    const firstHistory = computed(() => {
      const manager = lodash.get(unref(currentTenancy), 'manager.displayName')
      const createdAt = lodash.get(unref(currentTenancy), 'createdAt')
      return {
        status: i18n.t('status.active').toUpperCase(),
        displayName: manager,
        date: dateUtil.formatByLongDate(createdAt, 'L LT'),
        createdAt,
      }
    })
    const parsedHistories = computed(() => {
      const result = unref(histories)
        .filter(item => item.detail.type === TENANCY_HISTORY_TYPE.LIFECYCLE)
        .map(item => {
          return {
            status: i18n.t(`status.${item.status.toLowerCase()}`).toUpperCase(),
            displayName: item.who.displayName,
            date: dateUtil.formatByLongDate(item.createdAt, 'L LT'),
            createdAt: item.createdAt,
          }
        })
      result.unshift(unref(firstHistory))
      return lodash.orderBy(result, ['createdAt']).reverse()
    })
    return {
      columns,
      parsedHistories,
      ...modalHook,
    }
  },
}
</script>
